import state from "./application-state";
import mutations from "./application-mutations";
import actions from "./application-actions";
import getters from "./application-getters";
const DeprecatedApplicationStore = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
export default DeprecatedApplicationStore;